package com.fireavert.auth.shared

data class AuthErrorState(val error: Boolean = false,
                          val message: String = "")